<template>
  <div class="confirm-payment">
    <div class="pay-content">
      <div class="w-full">
        <template>
          <slot name="pay-content"></slot>
        </template>
        <div class="pay-mode flex items-center">
          <span>支付方式：</span>
          <el-radio-group>
            <el-radio>
              <span> {{ balanceText }}（{{ balance }}） </span>
            </el-radio>
          </el-radio-group>
          <div class="text-red" v-html="errorText" @click="tapText">
            <!-- {{ errorText }} -->
          </div>
        </div>
        <div v-if="showManagersFlag" class="business">
          <p>企业管理员：</p>
          <ul class="business-manager">
            <li v-for="manager in businessManagers" :key="manager">
              {{ manager }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="py-4 px-8 text-right">
      <template v-if="isShowCancelBtn">
        <el-button @click="onClickCancel">取消</el-button>
      </template>
      <template v-if="isShowPrevBtn">
        <el-button @click="onClickBack">上一步</el-button>
      </template>
      <template v-if="!disableRechargeBtn">
        <el-button v-if="showConfirmPaymentBtn" type="primary" :disabled="!disableConfirmPaymentBtn || disabled" @click="confirm">
          确认支付
        </el-button>
        <el-button v-else type="primary" :disabled="disableRechargeBtn || disabled" @click="recharge"> 去充值 </el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="$emit('submit-approval')">提交审批</el-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmPayment',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    amount: {
      type: [Number, String], // 需要支付的金额
      default: 0.0
    },
    balance: {
      // 余额
      type: [Number, String],
      default: 0.0
    },
    manager: {
      type: Boolean,
      default: false
    },
    disabledRecharge: {
      // 是否可以充值
      type: Boolean,
      default: false
    },
    isBusinessUser: {
      // 是否是企业用户
      type: Boolean,
      default: false
    },
    paymentAuthority: {
      // 有无使用企业账户支付权限
      type: Boolean,
      default: false
    },
    businessName: {
      // 企业名称
      type: String,
      default: ''
    },
    businessManagers: {
      type: Array,
      default: () => []
    },
    isShowPrevBtn: {
      // 是否显示上一页按钮
      type: Boolean,
      default: false
    },
    isShowCancelBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // showManagerList: false, // 是否显示管理员列表
    }
  },
  computed: {
    balanceText() {
      return this.isBusinessUser ? '企业账户余额' : '账户余额'
    },
    showConfirmPaymentBtn() {
      return parseFloat(this.balance) >= parseFloat(this.amount)
    },
    disableConfirmPaymentBtn() {
      let result = true
      if (this.isBusinessUser && !this.manager) {
        result = this.paymentAuthority
      }
      return result
    },
    disableRechargeBtn() {
      return !this.manager && this.isBusinessUser
    },
    showManagersFlag() {
      if (this.manager) {
        return false
      }
      return !this.paymentAuthority || !this.showConfirmPaymentBtn
    },
    errorText() {
      let result = ''
      if (!this.showConfirmPaymentBtn) {
        // result = '余额不足，请先充值，再完成支付'
        result =
          `可用余额不足，请先` +
          `<span class="bind-click-pay" style="color: #227FFE; cursor: pointer;">去充值</span>` +
          `充值后请刷新页面`
      }
      if (!this.isBusinessUser && this.manager) {
        return result
      }
      if (!this.paymentAuthority && !this.manager) {
        result = '您没有支付权限，请向企业管理员提交支付审批'
      } else if (!this.manager && !this.showConfirmPaymentBtn) {
        result = '余额不足，您没有充值权限，请向企业管理员提交充值审批。'
        // result = '余额不足，请先联系管理员充值，再完成支付。'
      }
      return result
    }
  },
  methods: {
    tapText(event) {
      if (event.target.nodeName === 'SPAN' && event.target.className === 'bind-click-pay') {
        this.recharge()
      }
    },
    onClickCancel() {
      this.$emit('cancel')
    },
    recharge() {
      this.$emit('recharge')
    },
    confirm() {
      this.$emit('confirm')
    },
    onClickBack() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped lang="scss">
.pay-content {
  display: flex;
  padding: 30px 50px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  height: 25vw;

  .pay-mode {
    border-top: 1px solid #909090;
    margin-top: 24px;
    padding: 20px 45px;
  }

  .business {
    background-color: #f5f5f5;
    padding: 20px 40px;

    .business-manager {
      display: grid;
      grid-template-columns: repeat(auto-fill, 33.33%);
      justify-content: space-around;

      li {
        line-height: 36px;
      }
    }
  }
}
</style>
